export default __webpack_public_path__ + "static/media/emailblock1.01ebfebc.svg";